import React, { useState, useEffect } from "react";
import API_BASE_URL from "./../apiConfig";

function Advertisement({ content }) {
  const announcement = content?.announcementText || "";

  return (
    <div className="container">
      <marquee>{announcement ? announcement : "Loading announcement..."}</marquee>
    </div>
  );
}

export default Advertisement;


// import React from 'react';

// function Advertisement() {
//   return (
//    <div>
//      <div classNmae="container">
//       <marquee>Help Help Help Help Help Help Help Help Help Help Help Help</marquee>
//      </div>
//   </div>
//   );
// }

// export default Advertisement;
